<app-loader></app-loader>
<div class="min-h-screen d-flex flex-column" [class.isIE11]="isIE11">
  <div>
    <div *ngIf="!isUnityDirect" class="sticky-shell">
      <app-header-bar></app-header-bar>
      <app-global-alert></app-global-alert>
    </div>

    <!-- DON'T combine the below 2 in the same ngIf. Needed for sticky header-->
    <div *ngIf="isUnityDirect">
      <app-portal-header *ngIf="isDisplay"></app-portal-header>
    </div>
    <div *ngIf="isUnityDirect" class="sticky-shell">
      <app-unity-direct-header-bar></app-unity-direct-header-bar>
    </div>

    <main
      [class.container]="!isISAOpen && !isBillingPageContainer"
      [class.container-express]="
        !isISAOpen && !isBillingPageContainer && !isUnityDirect
      "
      [class.container-100]="isISAOpen"
      [class.container-98]="!isISAOpen && isBillingPageContainer">
      <router-outlet></router-outlet>
    </main>

    <live-chat></live-chat>
    <app-dynamics-js></app-dynamics-js>
  </div>
  <app-site-footer></app-site-footer>
</div>
